/**
 * U SSO
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { DrivingLicenseResult } from '../model/drivingLicenseResult';
// @ts-ignore
import { PassportParams } from '../model/passportParams';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';
import {
    PassportServiceInterface
} from './passport.serviceInterface';



@Injectable({
  providedIn: 'root'
})
export class PassportService extends BaseService implements PassportServiceInterface {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * deletePassport
     * Service to delete a Passport. &lt;hr&gt;  Requires authorization of any of following types:  * APPLICATION_AUTH_BASIC * APPLICATION_BEARER_TOKEN * OAUTH_APPLICATION_CLIENT_CREDENTIAL  Token subjects allowed:  * AUTHENTICATE_APPLICATION
     * @param idUserHash Id User Hash
     * @param countryCode CountryCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deletePassport(idUserHash: string, countryCode: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deletePassport(idUserHash: string, countryCode: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deletePassport(idUserHash: string, countryCode: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deletePassport(idUserHash: string, countryCode: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (idUserHash === null || idUserHash === undefined) {
            throw new Error('Required parameter idUserHash was null or undefined when calling deletePassport.');
        }
        if (countryCode === null || countryCode === undefined) {
            throw new Error('Required parameter countryCode was null or undefined when calling deletePassport.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (APPLICATION_AUTH_BASIC) required
        localVarHeaders = this.configuration.addCredentialToHeaders('APPLICATION_AUTH_BASIC', 'Authorization', localVarHeaders, 'Basic ');

        // authentication (APPLICATION_BEARER_TOKEN) required
        localVarHeaders = this.configuration.addCredentialToHeaders('APPLICATION_BEARER_TOKEN', 'Authorization', localVarHeaders);

        // authentication (OAUTH_APPLICATION_CLIENT_CREDENTIAL) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_APPLICATION_CLIENT_CREDENTIAL', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/Passport/${this.configuration.encodeParam({name: "idUserHash", value: idUserHash, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/${this.configuration.encodeParam({name: "countryCode", value: countryCode, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('delete', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * getPassport
     * Service to get one Passport. &lt;hr&gt;  Requires authorization of any of following types:  * APPLICATION_AUTH_BASIC * APPLICATION_BEARER_TOKEN * OAUTH_APPLICATION_CLIENT_CREDENTIAL  Token subjects allowed:  * AUTHENTICATE_APPLICATION
     * @param idUserHash Id User Hash
     * @param countryCode CountryCode
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getPassport(idUserHash: string, countryCode: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<DrivingLicenseResult>;
    public getPassport(idUserHash: string, countryCode: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<DrivingLicenseResult>>;
    public getPassport(idUserHash: string, countryCode: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<DrivingLicenseResult>>;
    public getPassport(idUserHash: string, countryCode: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (idUserHash === null || idUserHash === undefined) {
            throw new Error('Required parameter idUserHash was null or undefined when calling getPassport.');
        }
        if (countryCode === null || countryCode === undefined) {
            throw new Error('Required parameter countryCode was null or undefined when calling getPassport.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (APPLICATION_AUTH_BASIC) required
        localVarHeaders = this.configuration.addCredentialToHeaders('APPLICATION_AUTH_BASIC', 'Authorization', localVarHeaders, 'Basic ');

        // authentication (APPLICATION_BEARER_TOKEN) required
        localVarHeaders = this.configuration.addCredentialToHeaders('APPLICATION_BEARER_TOKEN', 'Authorization', localVarHeaders);

        // authentication (OAUTH_APPLICATION_CLIENT_CREDENTIAL) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_APPLICATION_CLIENT_CREDENTIAL', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/Passport/${this.configuration.encodeParam({name: "idUserHash", value: idUserHash, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}/${this.configuration.encodeParam({name: "countryCode", value: countryCode, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<DrivingLicenseResult>('get', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * insertPassport
     * Service to create one Passport. &lt;hr&gt;  Requires authorization of any of following types:  * APPLICATION_AUTH_BASIC * APPLICATION_BEARER_TOKEN * OAUTH_APPLICATION_CLIENT_CREDENTIAL  Token subjects allowed:  * AUTHENTICATE_APPLICATION
     * @param passportParams Passport Param
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public insertPassport(passportParams: PassportParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public insertPassport(passportParams: PassportParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public insertPassport(passportParams: PassportParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public insertPassport(passportParams: PassportParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (passportParams === null || passportParams === undefined) {
            throw new Error('Required parameter passportParams was null or undefined when calling insertPassport.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (APPLICATION_AUTH_BASIC) required
        localVarHeaders = this.configuration.addCredentialToHeaders('APPLICATION_AUTH_BASIC', 'Authorization', localVarHeaders, 'Basic ');

        // authentication (APPLICATION_BEARER_TOKEN) required
        localVarHeaders = this.configuration.addCredentialToHeaders('APPLICATION_BEARER_TOKEN', 'Authorization', localVarHeaders);

        // authentication (OAUTH_APPLICATION_CLIENT_CREDENTIAL) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_APPLICATION_CLIENT_CREDENTIAL', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/Passport`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('post', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: passportParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * updatePassport
     * Service to update a Passport. &lt;hr&gt;  Requires authorization of any of following types:  * APPLICATION_AUTH_BASIC * APPLICATION_BEARER_TOKEN * OAUTH_APPLICATION_CLIENT_CREDENTIAL  Token subjects allowed:  * AUTHENTICATE_APPLICATION
     * @param passportParams Passport Param
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updatePassport(passportParams: PassportParams, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public updatePassport(passportParams: PassportParams, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public updatePassport(passportParams: PassportParams, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public updatePassport(passportParams: PassportParams, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (passportParams === null || passportParams === undefined) {
            throw new Error('Required parameter passportParams was null or undefined when calling updatePassport.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (APPLICATION_AUTH_BASIC) required
        localVarHeaders = this.configuration.addCredentialToHeaders('APPLICATION_AUTH_BASIC', 'Authorization', localVarHeaders, 'Basic ');

        // authentication (APPLICATION_BEARER_TOKEN) required
        localVarHeaders = this.configuration.addCredentialToHeaders('APPLICATION_BEARER_TOKEN', 'Authorization', localVarHeaders);

        // authentication (OAUTH_APPLICATION_CLIENT_CREDENTIAL) required
        localVarHeaders = this.configuration.addCredentialToHeaders('OAUTH_APPLICATION_CLIENT_CREDENTIAL', 'Authorization', localVarHeaders, 'Bearer ');

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/Passport`;
        const { basePath, withCredentials } = this.configuration;
        return this.httpClient.request<any>('put', `${basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: passportParams,
                responseType: <any>responseType_,
                ...(withCredentials ? { withCredentials } : {}),
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
